/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProvidersEnum } from './cloudProvidersEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { IrrApiVersionEnum } from './irrApiVersionEnum';
import { IrrSaasCapabilities } from './irrSaasCapabilities';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';
import { SubscriptionSpec } from './subscriptionSpec';


export interface DeploymentRegionLinkSpec { 
    service_type: ServiceTypeEnum;
    vcds_service_type: VcdsServiceTypeEnum;
    provider: CloudProvidersEnum;
    /**
     * Cloud Provider Region ID
     */
    region: string;
    /**
     * IP address of gateway
     */
    gateway_ip: string;
    /**
     * Force link will make this API idempotent and so that re-linking does not fail for duplicate records.
     */
    force_link?: boolean;
    /**
     * Create DNS entry in Route53
     */
    generate_dns_entry?: boolean;
    irr_api_version?: IrrApiVersionEnum;
    /**
     * Version of IRR. If specified, version will not be polled from EC2 instance. If skip_org_ip_validation is enabled, this value will be ignored.
     */
    irr_version?: string;
    /**
     * Set to true when a fake IRR gateway IP is used (MOCK provider) and IRR config push should be skipped
     */
    skip_gateway_config?: boolean;
    /**
     * Operator can skip several level of org and Ip address validation to be less strict.
     */
    skip_org_ip_validation?: boolean;
    subscription?: SubscriptionSpec;
    capabilities?: IrrSaasCapabilities;
}
export namespace DeploymentRegionLinkSpec {
}


